<template>
  <svg xmlns="http://www.w3.org/2000/svg" :viewBox="viewBox" :width="width + 'px'" :height="height + 'px'">
    <slot name="default"/>
  </svg>
</template>

<script>
export default {
  name: "svgBase",

  props: {
    width: {
      type: [String, Number],
      default: 40
    },
    height: {
      type: [String, Number],
      default: 40
    }
  },

  computed: {
    viewBox() {
      if (this.$attrs['view-box']) {
        if (typeof this.$attrs['view-box'] === 'number') {

          return `0 0 ${this.$attrs['view-box']} ${this.$attrs['view-box']}`
        } else
          return this.$attrs['view-box']
      }
      return `0 0 ${Number(this.width) + 8} ${Number(this.height) + 8}`
    }
  }
}
</script>

<style scoped>
svg {
  transition: .2s ease-in-out;
}
</style>